import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import AdminDashboard from './pages/AdminDashboard';
import LoginPage from './pages/LoginPage';
import MsalCallbackPage from './pages/MsalCallbackPage';
import QuantDashboard from './pages/QuantDashboard';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function DashboardRoute() {
  const { user } = useAuth();
  const [view, setView] = React.useState<'admin' | 'quant'>('admin');
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'gsw_admin') return <QuantDashboard />;
  return view === 'admin' ? (
    <AdminDashboard onSwitchToQuant={() => setView('quant')} />
  ) : (
    <QuantDashboard onSwitchToAdmin={() => setView('admin')} />
  );
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<MsalCallbackPage />} />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <DashboardRoute />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to={user ? '/dashboard' : '/login'} replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
